<script>
	import {push} from "svelte-spa-router";
	export let data = {};
	function go(){
		push(`/${data.tipo}/${data.documento}`);
	}
</script>
<div on:click={go} class="my-4 p-4 bg-white rounded flex shadow divide-x-2 divide-pink-500 hover:shadow-md cursor-pointer">
	<div class="flex items-center justify-center text-xl">
		{#if data.tipo == "cliente"}
			<i class="ri-user-smile-line p-2" />
		{:else}
			<i class="ri-bear-smile-line p-2" />
		{/if}
	</div>
	<div class="flex items-center justify-between w-full flex-row">
		<div class="flex flex-col items-start mx-2">
			<span class="text-sm font-bold">Nombre</span>
			{data.nombre}
		</div>
		<div class="flex flex-col items-start mx-2">
			<span class="text-sm font-bold">Documento</span>
			{data.documento}
		</div>
		{#if data.tipo =="cliente"}
		<div class="flex flex-col items-start mx-2 hidden sm:flex">
			<span class="text-sm font-bold">Telefono</span>
			{data.telefono}
		</div>
		<div class="flex flex-col items-start mx-2 hidden sm:flex">
			<span class="text-sm font-bold">Dirección</span>
			{data.direccion}
		</div>
		{:else}
		<div class="flex flex-col items-start mx-2">
			<span class="text-sm font-bold">Dueño</span>
			{data.dueno}
		</div>	
		<div class="flex flex-col items-start mx-2 hidden sm:flex">
			<span class="text-sm font-bold">Especie</span>
			{data.especie}
		</div>	
		{/if}
	</div>
</div>
